module.exports = __webpack_public_path__ + "img/广告媒体.f276488e.png";